import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class MlosLeadTimeRuleModel extends Model {
  @attr('number') threshold!: number;
  @attr('number') mlosValue!: number;
  @attr('boolean') enabled!: boolean;

  @belongsTo('property', {
    inverse: null,
    async: false,
  })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'mlos-lead-time-rule': MlosLeadTimeRuleModel;
  }
}
